/*
 * @Author: caiqin.xie
 * @since: 2023-06-29 15:49:13
 * @lastTime: 2023-11-10 15:38:46
 * @LastEditors: caiqin.xie
 * @message: 最近门店-门店列表组件
 */
import React from "react";
import CarouselShopItem from "../../../components/CarouselShopItem";
import styles from "../../index.module.scss";
import { IShop } from "@/common/types";

interface IProps {
  shopList: IShop[]; // 门店列表
  allShopList: IShop[]; // 所有门店列表
  device: string;
}

const ShopList = (props:IProps) => {
  const {device, shopList, allShopList} = props;
  const list = device === 'pc' ? shopList : allShopList

  return (
    <div className={styles['store-list']}>
      {list.map((shop:IShop) => (
        <CarouselShopItem shop={shop} carousel={false} key={shop.id} />
      ))}
    </div>
  )
}

export default ShopList;
